"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Marker = exports.MarkerNode = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
exports.MarkerNode = app_1.styled.div `
  cursor: pointer;
  position: relative;
  height: 0.8rem;
  width: 0.8rem;
  background: ${(theme, { $active }) => $active ? theme.colors.primary : theme.colors.secondary};
  border-radius: 99999px;
  z-index: ${(_, { $active }) => ($active ? 3 : 2)};
`;
function Marker({ lat, lng, onClick, active = false, children, }) {
    return ((0, jsx_runtime_1.jsx)(exports.MarkerNode, Object.assign({ lat: lat, lng: lng, "$active": active, onClick: onClick }, { children: active && children })));
}
exports.Marker = Marker;
